// BD-1016: dashboard-wide "exclude disabled users" toggle. Off by default; NBD-25
// restores it per tenancy from sessionStorage for the rest of the session. Module-level
// rather than React context because index.js issues its hydration queries above
// any provider it could render. useDashboardData folds it into every request as
// scope.excludeDisabled; the server drops Enabled = false users from each widget.
import { useSyncExternalStore } from 'react';

let excludeDisabled = false;
const listeners = new Set();

export function getExcludeDisabled() {
    return excludeDisabled;
}

export function setExcludeDisabled(value) {
    const next = Boolean(value);
    if (next === excludeDisabled) return;
    excludeDisabled = next;
    listeners.forEach((fn) => fn());
}

function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function useExcludeDisabled() {
    return useSyncExternalStore(subscribe, getExcludeDisabled);
}
